import {
  NavigationContainer,
  NavigatorScreenParams,
  useNavigationContainerRef,
} from "@react-navigation/native";
import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React, { useRef } from "react";

import { useAppSelector } from "@/hooks/application/store";
import analytics from "@/services/analytics";

import RootStack, { RootRoutePaths, RootStackParamList } from "./Root";
import navigationService from "./navigationService";
import AuthStack, { AuthRoutePaths, AuthStackParamList } from "./stacks/AuthenticationStack";

export type MainStackParamList = {
  root: NavigatorScreenParams<RootStackParamList>;
  auth: NavigatorScreenParams<AuthStackParamList>;
};

export type MainNavigation = StackNavigationProp<MainStackParamList>;

const Main = createStackNavigator<MainStackParamList>();

const config = {
  screens: {
    root: {
      screens: RootRoutePaths,
    },
    auth: {
      screens: AuthRoutePaths,
    },
  },
};

const linking = {
  prefixes: [],
  config,
};

const Navigation = () => {
  const navigationRef = useNavigationContainerRef();
  const routeNameRef = useRef<any>();
  const { logged } = useAppSelector((store) => store.auth);

  return (
    <NavigationContainer
      ref={navigationRef}
      linking={linking}
      onReady={() => {
        routeNameRef.current = navigationRef.getCurrentRoute().name;
        navigationService.setTopLevelNavigator(navigationRef);
      }}
      onStateChange={() => {
        const previousRouteName = routeNameRef.current;
        const currentRouteName = navigationRef.getCurrentRoute().name;
        if (previousRouteName !== currentRouteName) {
          analytics.logFirebaseScreenView(currentRouteName);
        }
        routeNameRef.current = currentRouteName;
      }}>
      <Main.Navigator
        initialRouteName={logged ? "root" : "auth"}
        screenOptions={{ headerShown: false }}>
        {logged ? (
          <Main.Screen name="root" component={RootStack} />
        ) : (
          <Main.Screen name="auth" component={AuthStack} />
        )}
      </Main.Navigator>
    </NavigationContainer>
  );
};

export default Navigation;
